/* src/app/components/controls/sem-file-upload/sem-file-upload.component.css */
#dragndrop {
  position: relative;
}
.img-main-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.85;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
}
.img-main-remove:hover {
  opacity: 1;
}
/*# sourceMappingURL=sem-file-upload.component.css.map */
